var __last_focused_element = null;
function setLastFocused() {
  __last_focused_element = arguments[0] || $(":focus");
}
function getLastFocused() {
  return __last_focused_element;
}
function focusLastFocused() {
  if (__last_focused_element) __last_focused_element.focus();
}

//usage: observeDOM(element, callback_function)
var observeDOM = (function () {
  var MutationObserver =
    window.MutationObserver || window.WebKitMutationObserver;

  return function (obj, callback) {
    if (!obj || obj.nodeType !== 1) return;

    if (MutationObserver) {
      // define a new observer
      var mutationObserver = new MutationObserver(callback);

      // have the observer observe for changes in children
      mutationObserver.observe(obj, { childList: true, subtree: true });
      return mutationObserver;
    }

    // browser support fallback
    else if (window.addEventListener) {
      obj.addEventListener("DOMNodeInserted", callback, false);
      obj.addEventListener("DOMNodeRemoved", callback, false);
    }
  };
})();

function initSelectStyle() {
  $ = jQuery;
  $(".ai-custom-select").each(function () {
    var $container = $(this);

    // Check if the select list has already been initialized
    if ($container.hasClass("select-initialized")) {
      return; // Skip this container, it's already initialized
    }

    var $select = $container.find("select");
    var selectedText = $select.find(":selected").text();
    var selectedValue = $select.find(":selected").val();

    var $aiDropdown = $('<div class="ai-dropdown">');
    var $aiDropdownSelected = $('<div class="ai-dropdown-selected">').text(
      selectedText
    );
    var $aiDropdownOptions = $('<ul class="ai-dropdown-options">');

    $select.hide();

    $select.find("option").each(function () {
      var optionText = $(this).text();
      var optionValue = $(this).val();
      var $listItem = $('<li data-value="' + optionValue + '">').text(
        optionText
      );

      // Set active class on initially selected item
      if (optionValue === selectedValue) {
        $listItem.addClass("active");
      }

      $listItem.click(function () {
        // Update the selected option text and class
        $aiDropdownSelected.text(optionText).toggleClass("on");
        $select.val(optionValue);
        $aiDropdownOptions.slideToggle();
        $select.trigger("change");

        // Set active class to the selected item and remove from others
        $aiDropdownOptions.find("li").removeClass("active");
        $listItem.addClass("active");
      });

      $aiDropdownOptions.append($listItem);
    });

    $aiDropdown.append($aiDropdownSelected);
    $aiDropdown.append($aiDropdownOptions);
    $container.append($aiDropdown);

    $aiDropdownSelected.click(function () {
      $(this).toggleClass("on");
      $aiDropdownOptions.slideToggle();
    });

    $select.on("change", function () {
      var selectedOption = $select.find(":selected");
      var selectedText = selectedOption.text();
      var selectedValue = selectedOption.val();

      $aiDropdownSelected.text(selectedText);
      $select.val(selectedValue);

      // Update active class based on programmatically changed selection
      $aiDropdownOptions.find("li").removeClass("active");
      $aiDropdownOptions
        .find('li[data-value="' + selectedValue + '"]')
        .addClass("active");
    });

    $(document).on("click", function (event) {
      if (
        !$(event.target).closest($aiDropdown).length &&
        !$(event.target).closest($select).length
      ) {
        $aiDropdownOptions.slideUp();
        $aiDropdownSelected.removeClass("on");
      }
    });

    // Mark the container as initialized
    $container.addClass("select-initialized");
  });
}

jQuery(document)
  .ready(function ($) {
    // Simple accordion functionality
    $(".accordion__group button").on("click", function (e) {
      e.preventDefault(); // If item clicked on is open, close it
      var $button = $(this);
      var $accordionGroup = $button.closest(".accordion__group");
      var $accordionCopy = $accordionGroup.find(".accordion__copy");

      if ($accordionGroup.hasClass("active")) {
        $accordionGroup.removeClass("active");
        $accordionCopy.slideUp();
        $button.attr("aria-expanded", "false");
      } else {
        // Otherwise, close all others and open the one clicked on
        $(".accordion__group").removeClass("active");
        $(".accordion__group button").attr("aria-expanded", "false");
        $(".accordion__copy").slideUp();

        $accordionGroup.addClass("active");
        $button.attr("aria-expanded", "true");
        $accordionCopy.slideDown();
      }
    });

    initLabelledInputs();
    initForms();

    ADA();

   
    switchToBlogTabIfNoProducts();
    
    var $atcButton = $(
      ".pdp .pdp__info .pdp__actions--flex .action.action--atc"
    );
    var $atcButtonContainer = $(".pdp .pdp__info .pdp__actions--flex");
    var $headerMain = $(".header-main");
    var $alertBar = $(".alert-bar");

    function updateStickyButton() {
      if ($atcButton.length > 0) {
        var atcButtonContainerBottom =
          $atcButtonContainer.offset().top + $atcButtonContainer.outerHeight();
        $atcButton.toggleClass(
          "sticky",
          $(window).scrollTop() > atcButtonContainerBottom
        );
        if ($(window).scrollTop() > atcButtonContainerBottom) {
          var headerHeight = $headerMain.outerHeight() || 0;
          var alertBarHeight = $alertBar.outerHeight() || 0;
          var totalHeaderHeight = headerHeight + alertBarHeight;
          $atcButton.css({
            top: totalHeaderHeight,
          });
        }
      }
    }

    function updateScreenDecorationPosition() {
      if ($(".pdp__herbs").length > 0) {
        var gridPosition = $(".pdp__grid").position().top;
        var herbsPosition = $(".pdp__herbs").position().top;
        $(".pdp__screen__l").css({
          top: herbsPosition,
        });
        $(".pdp__screen__tr").css({
          top: gridPosition,
        });
      }
    }

    function addInitialsToReviews() {
      $(".pdp__reviews .yotpo-reviewer-name").each(function () {
        var name = $(this).text().trim();
        var initials = name
          .split(" ")
          .map((word) => word.charAt(0))
          .join("");

        if (!$(this).parent().find(".reviewer-initials").length) {
          $(this)
            .parent()
            .prepend('<i class="reviewer-initials">' + initials + "</i>");
        }
      });
    }
    function observeYotpoReviews() {
      const reviewContainer = document.getElementById(
        "yotpo-reviews-container"
      );

      if (reviewContainer) {
        const config = { childList: true, subtree: true };
        const observer = new MutationObserver(function () {
          addInitialsToReviews();
        });
        observer.observe(reviewContainer, config);
      }
    }

    function moveReviewButton() {
      var reviewButton = $(".yotpo-new-review-btn-wrapper");
      var reviewsContainer = $("#yotpo-reviews-container");
      var originalContainer = $(".yotpo-layout-header-wrapper");

      $(
        ".pdp__reviews .yotpo-vertical-pagination .yotpo-reviews-pagination-item"
      ).text("Show More");

      if ($(window).width() < 769) {
        reviewButton.insertAfter(reviewsContainer);
      } else {
        reviewButton.appendTo(originalContainer);
      }
    }

    function movePdpHeading() {
      if ($(window).width() < 769) {
        if (!$(".pdp__heading").prev(".pdp__grid").length) {
          $(".pdp .pdp__heading").insertBefore(".pdp__grid");
          $(".pdp .container").css('padding-top', '0px');
        }
      } else {
        if (!$(".pdp__info__box .pdp__heading").length) {
          $(".pdp .pdp__heading").prependTo(".pdp .pdp__info__box");
        }
      }
    }

    var rellax;
    function initRellax() {
      if (
        $(".pdp__herbs").length > 0 ||
        $(".deco-tr").length > 0 ||
        $(".deco-ml").length > 0 ||
        $(".deco-br").length > 0
      ) {
        if (rellax === undefined && $(window).width() >= 769) {
          rellax = new Rellax(".rellax", {
            center: true,
          });
        } else if (rellax !== undefined && $(window).width() < 769) {
          rellax.destroy();
          rellax = undefined;
        }
        if (rellax) {
          rellax.refresh();
        }
      }
    }

    $(".herb__box__inner").each(function () {
      let touchstartX = 0;
      let touchendX = 0;
      const box = $(this);

      box.on("touchstart", function (e) {
        touchstartX = e.originalEvent.changedTouches[0].screenX;
      });

      box.on("touchend", function (e) {
        touchendX = e.originalEvent.changedTouches[0].screenX;
        handleSwipe();
      });

      function handleSwipe() {
        if ($(window).width() <= 768) {
          if (touchstartX > touchendX + 50) {
            // swipe left
            box.addClass("active");
          } else if (touchstartX < touchendX - 50) {
            // swipe right
            box.removeClass("active");
          }
        }
      }
    });

    const $activePathwayList = $(
      ".pathway-list .active, .topic__filter ul li a.current"
    );
    if ($activePathwayList.length) {
      $activePathwayList[0].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }

    $(window)
      .on("resize", function () {
        checkPdpGallerySlider();
        checkVideoCardsSlider();
        updateScreenDecorationPosition();
        updateStickyButton();
        moveReviewButton();
        movePdpHeading();
        initRellax();
        moveSubpageHeroSubtitle();
      })
      .trigger("resize");

    $(window).on("load", function () {
      updateScreenDecorationPosition();
      addInitialsToReviews();
      observeYotpoReviews();
      moveReviewButton();
      initRellax();
    });
    $(window).on("scroll", updateStickyButton);

    $(".article__recipe__gallery").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      accessibility: false,
      infinite: true,
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3500,
      rows: 0,
      instructionsText:
        "This is an auto-rotating carousel. Use the play and pause buttons to control the slides when multiple slides are available.",
    });

    $(".awards__items").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      accessibility: false,
      infinite: false,
      dots: false,
      arrows: true,
      prevArrow:
        '<i class="awards__items__prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M15.262 7.292a.98.98 0 0 1 0 1.416l-6.24 5.985a1.018 1.018 0 1 1-1.41-1.47L12.016 9H1.003a1 1 0 0 1 0-1.999h11.013L7.612 2.777a1.018 1.018 0 1 1 1.41-1.47l6.24 5.985Z" /></svg></i>',
      nextArrow:
        '<i class="awards__items__next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M15.262 7.292a.98.98 0 0 1 0 1.416l-6.24 5.985a1.018 1.018 0 1 1-1.41-1.47L12.016 9H1.003a1 1 0 0 1 0-1.999h11.013L7.612 2.777a1.018 1.018 0 1 1 1.41-1.47l6.24 5.985Z" /></svg></i>',
      autoplay: false,
      rows: 0,
      instructionsText:
        "This is an auto-rotating carousel. Use the play and pause buttons to control the slides when multiple slides are available.",
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          },
        },
      ],
    });
  })
  .on(
    "click",
    ".pdp__gallery__video .play-icon, .pdp__fwii__media .play-icon, .article__herb__video__box .play-icon, .collection__grid .play-icon, .article__default__video .play-icon, .featured-video figure .play-icon, .video-cards figure .play-icon, .social-reels__item figure .play-icon",
    function () {
      var $parent = $(this).parent();
      var $video = $parent.find("video").get(0);
      var $iframe = $parent.find("iframe");

      $parent.addClass("on");

      if ($video) {
        $video.play();

        $video.addEventListener("ended", function () {
          $parent.removeClass("on");
        });
      }
      if ($iframe.length) {
        var src = $iframe.attr("src");
        if (src.indexOf("autoplay=1") === -1) {
          if (src.indexOf("?") !== -1) {
            src += "&autoplay=1";
          } else {
            src += "?autoplay=1";
          }
          $iframe.attr("src", src);
        }
      }
    }
  )
  .on("click", ".pdp__accordion__heading", function () {
    var $button = $(this);
    var expanded = $button.attr("aria-expanded") === "true";

    $(".pdp__accordion__heading")
      .attr("aria-expanded", "false")
      .parent()
      .removeClass("on");
    $(".pdp__accordion__content").slideUp();

    if (!expanded) {
      $button.attr("aria-expanded", "true").parent().addClass("on");
      var $content = $("#" + $button.attr("aria-controls"));
      $content.slideDown();
    }
  })
  .on("click", ".pdp__nested-accordion__heading", function () {
    var $button = $(this);
    var expanded = $button.attr("aria-expanded") === "true";

    $(".pdp__nested-accordion__heading")
      .attr("aria-expanded", "false")
      .parent()
      .removeClass("on");
    $(".pdp__nested-accordion__content").slideUp();

    if (!expanded) {
      $button.attr("aria-expanded", "true").parent().addClass("on");
      var $content = $("#" + $button.attr("aria-controls"));
      $content.slideDown();
    }
  })
  .on("click", ".tablist__tab", function (e) {
    e.preventDefault();
    var $tabContainer = $(this).closest(".tabs-container"); // Get the closest tablist container
    var targetPanel = $(this).attr("aria-controls");

    // Remove active classes and attributes only within the current tablist
    $tabContainer
      .find(".tablist__tab")
      .removeClass("tablist__tab--active")
      .attr("aria-selected", "false")
      .attr("tabindex", "-1");
    $tabContainer
      .find(".tabpanel")
      .removeClass("tabpanel--active")
      .attr("tabindex", "-1");

    // Add active class and attributes to the clicked tab
    $(this)
      .addClass("tablist__tab--active")
      .attr("aria-selected", "true")
      .attr("tabindex", "0");
    $tabContainer
      .find("#" + targetPanel)
      .addClass("tabpanel--active")
      .attr("tabindex", "0");
  })
  .on("keydown", ".tablist__tab", function (e) {
    var $currentTab = $(this);
    var $tabs = $currentTab.closest(".tablist").find(".tablist__tab"); // Restrict tabs to current tablist
    var currentIndex = $tabs.index($currentTab);

    switch (e.keyCode) {
      case 37: // Left arrow key
      case 38: // Up arrow key
        if (currentIndex > 0) {
          $tabs
            .eq(currentIndex - 1)
            .click()
            .focus();
        }
        break;
      case 39: // Right arrow key
      case 40: // Down arrow key
        if (currentIndex < $tabs.length - 1) {
          $tabs
            .eq(currentIndex + 1)
            .click()
            .focus();
        }
        break;
    }
  });

jQuery(document).ready(function ($) {
  $(".customer--addresses .add-address").on("click", function (e) {
    $("#address-add").toggle();
    $("#address-list").toggle();
  });
  $(".customer--addresses .add-address-cancel").on("click", function (e) {
    $("#address-add").toggle();
    $("#address-list").toggle();
  });
});
jQuery(document).ready(function ($) {
  // Simple quantity box increase / decrease
  $(".js-qty:not(.js-qty--cart):not(.js-qty--mini)").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find("input");
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;

    if ($this.hasClass("js-qty--plus")) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }

    qtyInput.val(qtyInputVal);
    qtyInput.trigger("change");
  }); // PDP TEMPLATE
  // Change actual select for variant id ATC
  $(".pdp .pdp__variants input").on("click", function () {
    var varId = $(this).closest("label").attr("data-variant_id");
    $(this).closest(".pdp__variants").find("label").removeClass("active");
    $(this).closest("label").addClass("active"); 

    $(this).closest(".pdp")
      .find("[sm-rc-variant-selector]")
      .val(varId)
      .change();

    // Update the URL without reloading
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("variant", varId);
    window.history.replaceState(null, "", newUrl.toString());
  });

  const urlParams = new URLSearchParams(window.location.search);
  const selectedVariantId = urlParams.get("variant");
  if (selectedVariantId) {
    const $matchingLabel = $(`.pdp .pdp__variants label[data-variant_id="${selectedVariantId}"]`).find("input").trigger('click');
  }
  $(".pdp .pdp__recharge input").on("click", function () {
    if ($(this).val() == "rc-yes") {
      $(".pdp .form__group--rc").show();
      var planId = $(this)
        .closest(".pdp__recharge")
        .find(".frequency-select")
        .val();
      $(this).closest(".pdp")
        .find("[sm-rc-plan-selector]")
        .val(planId)
        .change();
    } else {
      $(".pdp .form__group--rc").hide();
      $(this).closest(".pdp")
        .find("[sm-rc-plan-selector]")
        .val("false")
        .change();
    }

    $(this).closest(".pdp__recharge").find("label").removeClass("active");
    $(this).closest("label").addClass("active");
  });
  $(".template__product .frequency-select").on("change", function () {
    var planId = $(this).val();
    $("[sm-rc-plan-selector]").val(planId).change();
  }); 
  
  // MODAL TEMPLATE

  $(".modal--pdp .pdp__variants input").on("click", function () {
    var varId = $(this).closest("label").attr("data-variant_id");
    $(this).closest(".pdp__variants").find("label").removeClass("active");
    $(this).closest("label").addClass("active"); 
    $(this)
      .closest(".modal")
      .find("[sm-rc-variant-selector]")
      .val(varId)
      .change();
  });
  $(".modal--pdp .pdp__recharge input").on("click", function () {
    var planId = $(this).closest("label").attr("data-plan_id");
    $(this)
      .closest(".modal")
      .find("[sm-rc-plan-selector]")
      .val(planId)
      .change();
  });
  $(".modal--pdp .pdp__recharge input").on("click", function () {
    if ($(this).val() == "rc-yes") {
      $(this).closest(".modal").find(".form__group--rc").show();
      var planId = $(this)
        .closest(".pdp__recharge")
        .find(".frequency-select")
        .val();
      $(this)
        .closest(".modal")
        .find("[sm-rc-plan-selector]")
        .val(planId)
        .change();
    } else {
      $(this).closest(".modal").find(".form__group--rc").hide();
      $(this)
        .closest(".modal")
        .find("[sm-rc-plan-selector]")
        .val("false")
        .change();
    }
  });
  $(".modal--pdp .frequency-select").on("change", function () {
    var planId = $(this).val();
    $(this)
      .closest(".modal")
      .find("[sm-rc-plan-selector]")
      .val(planId)
      .change();
  }); // Main Cart Qty

  $(".col__qty, .mobile-stuff").on("click", ".js-qty--cart", function (e) {
    e.preventDefault();
    var $this = $(this);
    var qtyInput = $this.closest(".qty").find("input");
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    var itemID = $this.closest(".cart-row").data("lineid");
    var lineNum = $this.closest(".cart-row").data("linenum");

    if ($this.hasClass("js-qty--plus")) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }

    if (qtyInputVal >= 1) {
      CartJS.updateItem(
        lineNum,
        qtyInputVal,
        {},
        {
          success: function success(data, textStatus, jqXHR) {
            jQuery.getJSON("/cart.js", function (cart) {
              $.each(cart.items, function (index, item) {
                if (item.id === itemID) {
                  $(
                    '[data-lineid="' +
                      itemID +
                      '"] .col__total, [data-lineid="' +
                      itemID +
                      '"] .mobile-stuff .section--total .data'
                  ).text(formatter.format(item.final_line_price / 100));
                  $(
                    '[data-lineid="' +
                      itemID +
                      '"] .col__qty input, [data-lineid="' +
                      itemID +
                      '"] .mobile-stuff .qty input'
                  ).val(item.quantity);
                }
              });
              $(".totals .total-money").text(
                formatter.format(cart.items_subtotal_price / 100)
              );
              var totalShip = parseInt($(".cart").data("freeship"));
              var newCartTotal = cart.items_subtotal_price;
              var awayShip = totalShip - newCartTotal;
              var shipPercent = (newCartTotal / totalShip) * 100; // console.log( 'totalShip: '+totalShip );
              // console.log( 'newCartTotal: '+newCartTotal );
              // console.log( 'awayShip: '+awayShip );
              // console.log( 'shipPercent: '+shipPercent );

              if (shipPercent >= 100) {
                $(".cart__ship  .shipping-bar--progress").css("width", "100%");
                $(".cart__ship ").addClass("is-free");
                $(".shipping-bar").attr("aria-valuenow", "100%");
              } else {
                if ($(".cart__ship ").hasClass("is-free")) {
                  $(".cart__ship ").removeClass("is-free");
                }

                $(".free-count").text(formatter.format(awayShip / 100));
                $(".shipping-bar--progress").css("width", shipPercent + "%");
                $(".shipping-bar").attr("aria-valuenow", shipPercent + "%");
              }
            });
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            console.log("Error: " + errorThrown + "!");
            console.log(textStatus);
            console.log(jqXHR);
          },
        }
      );
    } else {
      CartJS.removeItem(lineNum, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log("Error: " + errorThrown + "!");
          console.log(textStatus);
          console.log(jqXHR);
        },
      });
    }
  }); // Main Cart Remove

  $(".actions .remove-product").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);
    var itemID = $this.closest(".cart-row").data("lineid");
    var lineNum = $this.closest(".cart-row").data("linenum");
    $(".cart-row").each(function (index, value) {
      $dataLine = $(this).data("linenum"); // console.log( $dataLine );
    });
    CartJS.removeItemById(itemID, {
      success: function success(data, textStatus, jqXHR) {
        location.reload();
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log("Error: " + errorThrown + "!");
        console.log(textStatus);
        console.log(jqXHR);
      },
    });
  });
});
jQuery(document).ready(function ($) {
  // Make mobile category selector go to tag page
  $(".blog__tags select").on("change", function () {
    var tagUrl = $(this).val();
    window.location = tagUrl;
  });
});

jQuery(document).ready(function ($) {
  var windowW = $(window).width();

  $(window).on("resize", function () {
    windowW = $(window).width();
  });

  // Back to Top button
  $(".btn--top").on("click", function () {
    window.scrollTo(0, 0);
    $(".fixed-wrap").focus();
  });
  $('#email_signup--hero input[name="terms_check"]').on("click", function () {
    if ($(this).is(":checked")) {
      $("#email_signup--hero button").removeAttr("disabled");
    } else {
      $("#email_signup--hero button").attr("disabled", "disabled");
    }
  });
  $('#email_signup--footer input[name="terms_check"]').on("click", function () {
    if ($(this).is(":checked")) {
      $("#email_signup--footer button").removeAttr("disabled");
    } else {
      $("#email_signup--footer button").attr("disabled", "disabled");
    }
  });
  $('#email_signup--article input[name="terms_check"]').on(
    "click",
    function () {
      if ($(this).is(":checked")) {
        $("#email_signup--article button").removeAttr("disabled");
      } else {
        $("#email_signup--article button").attr("disabled", "disabled");
      }
    }
  );

  $("#email_signup--hero, #email_signup--footer, #email_signup--article").on(
    "submit",
    function () {
      var termCheck = $(this).find('input[name="terms_check"]');
      var email = $(this).find('input[name="email"]').val();
      if (!termCheck.is(":checked")) {
        $(this)
          .find(".error_message_2")
          .show()
          .html("Please select a privacy policy");
        return false;
      } else {
        $(this).find(".error_message_2").hide().html("");
      }
      if (!validateEmail(email)) {
        $(this).find(".error_message").show().html("Invalid email address");
        return false;
      } else {
        $(this).find(".error_message").hide().html("");
      }

      //console.log("OK");
      return true;
    }
  );

  // Mobile Menu
  $(".hamburger").on("click", function () {
    $(".hamburger").toggleClass("is-active");
    $("body").toggleClass("no-scroll");
    var mobileMenu = $(".mobile-menu");
    if (mobileMenu.is(":visible")) {
      mobileMenu.fadeOut();
      document.removeEventListener("keydown", trapMobileMenuFocus);
      focusLastFocused();
    } else {
      setLastFocused(this);
      mobileMenu.fadeIn();
      document.addEventListener("keydown", trapMobileMenuFocus);
      gateModal(mobileMenu);
    }
  });
  $(".mobile-menu .menu-header").on("click", function (e) {
    e.preventDefault();

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).next("ul").slideUp();
    } else {
      $(".mobile-menu .menu-header").removeClass("active");
      $(".mobile-menu ul ul").slideUp();
      $(this).addClass("active");
      $(this).next("ul").slideDown();
    }
  }); // Alert bar dropdown

  $(".alert-bar__select button").on("click", function () {
    $(this).toggleClass("active");
    $(this).next(".alert-bar__dropdown").slideToggle();
  }); // PDP Variants active class

  $(".pdp__recharge input").on("click", function (e) {
    $(this).closest(".pdp__recharge").find("label").removeClass("active");
    $(this).closest("label").addClass("active"); 
  }); 
  
  // Product Tab Slider

  $(".tab-slider .tab-buttons button").on("click", function () {
    var dataTab = $(this).data("id");

    if (!$(this).hasClass("eyebrow--border")) {
      $(".tab-slider .tab-buttons button").removeClass("eyebrow--border");
      $(this).addClass("eyebrow--border");
      $(".tab-slider .tab--active").fadeOut(300, function () {
        $(".tab-slider .tab--active").removeClass("tab--active");
        $(".tab-slider #" + dataTab)
          .fadeIn(300)
          .addClass("tab--active");
        $(".tab-slider #" + dataTab + " .slider").slick("setPosition");
      });
    }
  });
  $(".tab-slider select").on("change", function () {
    var dataTab = $(this).find(":selected").val();
    $(".tab-slider .tab--active").fadeOut(300, function () {
      $(".tab-slider .tab--active").removeClass("tab--active");
      $(".tab-slider #" + dataTab)
        .fadeIn(300)
        .addClass("tab--active");
      $(".tab-slider #" + dataTab + " .slider").slick("setPosition");
    });
  }); // PLP Modal

  $(document).on(
    "click",
    ".product-box .btn--add, .module-product-carousel .ai-carousel .quick-buy-modal, .article__default__promo .banner .btn",
    function (e) {
      e.preventDefault();
      productModal($(this));
    }
  ); // PLP Modal ( slider )
  // $( 'body' ).on( 'click', '.slide-product .face__actions .btn', function( e ){
  //   e.preventDefault();
  //   productModal( $( this ) );
  // } );
  // PDP Tabs

  function activateTab($tab) {
    var id = $tab.attr("aria-controls");

    if (!$tab.hasClass("eyebrow--border")) {
      $(".tabs__list button").removeClass("eyebrow--border");
      $tab.addClass("eyebrow--border");

      $(".tab").removeClass("tab--active");
      $("#" + id).addClass("tab--active");

      $(".tabs__list button")
        .attr("aria-selected", "false")
        .attr("tabindex", "-1");
      $tab.attr("aria-selected", "true").attr("tabindex", "0");
    }
  }

  // Handle click event on tabs
  $(".pdp__tabs .tabs__list button, .experts-tabs .tabs__list button").on(
    "click",
    function () {
      activateTab($(this));
    }
  );

  // Handle keyboard navigation
  $(".pdp__tabs .tabs__list button, .experts-tabs .tabs__list button").on(
    "keydown",
    function (e) {
      var $tabs = $(".tabs__list button");
      var currentIndex = $tabs.index(this);
      var newIndex = -1;

      switch (e.key) {
        case "ArrowLeft":
          newIndex = currentIndex > 0 ? currentIndex - 1 : $tabs.length - 1;
          break;
        case "ArrowRight":
          newIndex = currentIndex < $tabs.length - 1 ? currentIndex + 1 : 0;
          break;
        case "Enter":
        case " ":
          activateTab($(this));
          return;
      }

      if (newIndex !== -1) {
        $tabs.eq(newIndex).focus();
      }
    }
  );

  $(".note__action--sup a").on("click", function (e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $("#pdp-tabs").offset().top,
      },
      850
    );
    $('.tabs__list button[data-id="supplemental-info"]').click();
  }); // PDP Tabs -- Mobile

  $(".pdp__tabs .tab .mobile-trigger, .experts-tabs .tab .mobile-trigger").on(
    "click",
    function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).closest(".tab").find(".inner").slideUp();
      } else {
        $(".mobile-trigger").removeClass("active");
        $(".tab .inner").slideUp();
        $(this).addClass("active");
        $(this).closest(".tab").find(".inner").slideDown();
      }
    }
  ); // View more icons

  $(".icon-slider--simple .btn--more, .icon-slider--complex .btn--more").on(
    "click",
    function (e) {
      e.preventDefault();
      $(this)
        .closest(".shopify-section")
        .find(".slick-protect:hidden")
        .fadeIn();
      $(this).hide();
    }
  );

  // Footer mobile accordion
  $(".footer .footer__menus button").on("click", function () {
    if (windowW < 992) {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).closest(".menu").find("ul").slideUp();
      } else {
        $(".footer .footer__menus button").removeClass("active");
        $(".footer__menus .menu ul").slideUp();
        $(this).addClass("active");
        $(this).closest(".menu").find("ul").slideDown();
      }
    }
  });
  // Blog filter accordions

  $(".blog__sidebar .filter-wrap button").on("click", function () {
    var $filterWrap = $(this).closest(".filter-wrap");
    var $filterList = $filterWrap.find(".filter-list");
    var $button = $(this);

    if ($filterWrap.hasClass("active")) {
      $filterWrap.removeClass("active");
      $filterList.slideUp();
      $button.attr("aria-expanded", "false");
    } else {
      $(".filter-list").slideUp();
      $(".filter-wrap").removeClass("active");
      $(".filter-wrap button").attr("aria-expanded", "false");
      $filterWrap.addClass("active");
      $filterList.slideDown();
      $button.attr("aria-expanded", "true");
    }
  });

  $(".blog__sidebar .show-mobile button").on("click", function () {
    $(this).closest(".blog__sidebar").find(".sidebar__filters").slideToggle();
  }); // Herb library alphabetical filter

  $(".blog__alphabet button").on("click", function (e) {
    e.preventDefault();

    if (!$(this).hasClass("disabled")) {
      var letter = $(this).attr("data-letter");

      if (letter == "reset") {
        $(".blog__list .article--herb").fadeIn("fast");
      } else {
        $(".blog__list .article--herb")
          .fadeOut("fast")
          .promise()
          .done(function () {
            $(
              '.blog__list .article--herb[data-letter="' + letter + '"]'
            ).fadeIn("fast");
          });
      }
    }
  });
  $(".herb__research button").on("click", function () {
    $(this).closest(".herb__research").find(".copy").slideToggle();
  }); // Experts list view more

  $(".experts-list .show-more button").on("click", function () {
    $(".experts-list .show-more").hide();
    $(".experts-list .more-experts").slideDown();
  }); // Careers Tab Slider

  $(".article-slider--careers .tabs-list button").on("click", function () {
    var dataTab = $(this).data("id");

    if (!$(this).hasClass("eyebrow--border")) {
      $(".article-slider--careers .tabs-list button").removeClass(
        "eyebrow--border"
      );
      $(this).addClass("eyebrow--border");
      $(".article-slider--careers .tab--active").fadeOut(300, function () {
        $(".article-slider--careers .tab--active").removeClass("tab--active");
        $(".article-slider--careers #" + dataTab)
          .fadeIn(300)
          .addClass("tab--active");
        $(".article-slider--careers #" + dataTab + " .slider").slick(
          "setPosition"
        );
      });
    }
  }); // Careers Icon Tab Slider

  $(".icon-slider--tabs .tabs-list button").on("click", function () {
    var dataTab = $(this).data("id");

    if (!$(this).hasClass("eyebrow--border")) {
      $(".icon-slider--tabs .tabs-list button").removeClass("eyebrow--border");
      $(this).addClass("eyebrow--border");
      $(".icon-slider--tabs .tab--active").fadeOut(300, function () {
        $(".icon-slider--tabs .tab--active").removeClass("tab--active");
        $(".icon-slider--tabs #" + dataTab)
          .fadeIn(300)
          .addClass("tab--active");
        $(".icon-slider--tabs #" + dataTab + " .slider").slick("setPosition");
      });
    }
  }); // Timeline Slider

  $(".timeline__years .year").on("click", function () {
    var dataIndex = $(this).attr("data-index");
    $(".timeline__events .slider").slick("slickGoTo", dataIndex);
    $(this).addClass("active");
    $(this).prevAll().addClass("active");
    $(this).nextAll().removeClass("active");
  });

  function productModal(item) {
    setLastFocused(item);
    var productID = item.closest(".product").attr("data-id");
    var sliderMain = item
      .closest(".product")
      .attr("data-slider_main")
      .split("|")
      .filter(function (v) {
        return v !== "";
      });
    var sliderThumb = item
      .closest(".product")
      .attr("data-slider_thumb")
      .split("|")
      .filter(function (v) {
        return v !== "";
      });
    var varImage = item
      .closest(".product")
      .attr("data-var_images")
      .split("|")
      .filter(function (v) {
        return v !== "";
      });

    // Setup main slider HTML
    var sliderMainHtml = '<div class="modal__slider--main arrow--circle">';
    sliderMain.forEach(function (value) {
      let x = value.split("~~");
      let alt = x[1] || "";
      value = x[0];
      sliderMainHtml +=
        '<div class="slick-protect"><div class="inner"><img src="' +
        value +
        '" alt="' +
        alt +
        '" /></div></div>';
    });
    sliderMainHtml += "</div>";

    // Setup thumb slider HTML
    var sliderThumbHtml = '<div class="modal__slider--thumb dots--bar">';
    sliderThumb.forEach(function (value) {
      let x = value.split("~~");
      let alt = x[1] || "";
      value = x[0];
      if ($.inArray(value, varImage) !== -1) {
        var noVar = "";
      } else {
        var noVar = "no-var";
      }
      sliderThumbHtml +=
        '<div class="slick-protect ' +
        noVar +
        '"><img src="' +
        value +
        '" alt="' +
        alt +
        '" /></div>';
    });
    sliderThumbHtml += "</div>";

    // Append sliders to modal
    $("#modal-" + productID + " .modal__images").append(sliderMainHtml);
    $("#modal-" + productID + " .modal__images").append(sliderThumbHtml);

    // Initialize thumbnail slider
    $(".modal__images .modal__slider--thumb")
      .not(".slick-initialized")
      .slick({
        infinite: true,
        arrows: false,
        dots: true,
        slidesToShow: 6,
        focusOnSelect: true,
        asNavFor: ".modal__images .modal__slider--main",
        noRole: true,
        responsive: [
          {
            breakpoint: 993,
            settings: {
              slidesToShow: 6,
              vertical: false,
            },
          },
          {
            breakpoint: 577,
            settings: {
              slidesToShow: 3,
              vertical: false,
            },
          },
        ],
      });

    // Initialize main slider
    $(".modal__images .modal__slider--main").not(".slick-initialized").slick({
      infinite: true,
      fade: true,
      arrows: true,
      dots: false,
      asNavFor: ".modal__images .modal__slider--thumb",
      noRole: true,
    });

    // Manually sync thumbnail clicks with main slider
    $(".modal__images .modal__slider--thumb").on(
      "click",
      ".slick-slide",
      function (event) {
        var index = $(this).data("slick-index");
        console.log("Thumbnail clicked. Slide index: ", index);
        $(".modal__images .modal__slider--main").slick("slickGoTo", index);
      }
    );

    // Open modal and set slider positions
    $("#modal-" + productID).fadeIn();
    $("#modal-" + productID + " .modal__slider--main").slick("setPosition");
    $("#modal-" + productID + " .modal__slider--thumb").slick("setPosition");

    gateModal($("#modal-" + productID + " [role='dialog']"));
  }

  $(".header__nav .has-children > a, .header__nav .has-children > button").on(
    "click",
    function (e) {
      e.preventDefault();
      let parent = $(this).closest(".has-children");
      if ($(this).hasClass("active")) {
        $("> a, > button", ".header__nav .has-children").removeClass("active");
        $(
          "> a[aria-controls], > button[aria-controls]",
          ".header__nav .has-children"
        ).attr("aria-expanded", "false");
        $(".header__nav .has-children > .sub-menu ").hide();
      } else {
        $("> a, > button", ".header__nav .has-children").removeClass("active");
        $(
          "> a[aria-controls], > button[aria-controls]",
          ".header__nav .has-children"
        ).attr("aria-expanded", "false");
        $(".header__nav .has-children > .sub-menu ").hide();
        $(this).addClass("active");
        parent.find(" > [aria-controls]").attr("aria-expanded", "true");
        parent.find(" > .sub-menu ").show();
      }
    }
  );

  $(document).on("click", function (e) {
    var is_header_menu = e.target.closest(".header__nav");
    if (!is_header_menu) {
      $(
        ".header__nav .has-children > a.active ~ .sub-menu, .header__nav .has-children > button.active ~ .sub-menu"
      ).hide();
      $(
        ".header__nav .has-children > a.active, .header__nav .has-children > button.active"
      ).removeClass("active");
    }
  });

  $(".sub-menu--seo .has-sub a").on("click", function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      // $('.sub-menu--seo .has-sub a').removeClass('active');
      // $('.sub-menu--seo .menu-right').hide();
    } else {
      var dataID = $(this).attr("data-id");
      $(".sub-menu--seo .has-sub a").removeClass("active");
      $(this).addClass("active");
      $(".sub-menu--seo .menu-right").hide();
      $('.sub-menu--seo .menu-right[data-id="' + dataID + '"]').show();
    }
  });
});
jQuery(document).ready(function ($) {
  headerOffset(); // Update offset on scroll

  $(window).on("scroll resize", function () {
    setTimeout(function () {
      headerOffset();
    }, 200);
  }); // Update offset on alert bar close

  $(".alert-bar .close--alert").on("click", function () {
    $(".alert-bar").remove();
    headerOffset();
  }); // Show destkop search on click and focus on input

  $(".icon--search").on("click", function (e) {
    e.preventDefault();
    $(".desktop-search").fadeIn("fast", "", function () {
      $("body").addClass("search-open");
      $('.desktop-search input[type="text"]').focus();
    });
  }); // Close desktop search if click outside

  $("body").on("click", function (e) {
    var desktopSearch = $(".desktop-search");
    //$(".header-main .select-country .open-flags").next('.country-list').fadeOut();
    if (
      !desktopSearch.is(e.target) &&
      desktopSearch.has(e.target).length === 0 &&
      $("body").hasClass("search-open")
    ) {
      desktopSearch.fadeOut("fast", "", function () {
        $("body").removeClass("search-open");
        $(".icon--search").focus();
      });
    }
  }); // Offset content from fixed header

});
jQuery(document).ready(function ($) {
  var links = document.links; // console.log( 'links: '+links );

  for (var i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }
});
jQuery(document).ready(function ($) {
  // Close mini cart
  $(".mini-cart__bg, .mini-cart__content .close").on("click", function () {
    closeMini();
  }); // Show mini cart

  $(".header .icon--cart").on("click", function (e) {
    e.preventDefault();

    if (!$("body").hasClass("template__cart")) {
      showMini();
    } else {
      e.preventDefault();
    }
  }); // Mini Cart Remove Product

  $(".mini-cart").on("click", ".remove-product", function () {
    var lineNum = $(this).closest(".product").attr("data-lineid"); // console.log( lineNum );

    $(this).closest(".product").addClass("removed");
    CartJS.removeItem(lineNum, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON("/cart.js", function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        alert("Error: " + errorThrown + "!");
      },
    });
  }); // Mini Cart Upsell ATC

  $(".mini-cart__upsell .action--atc").on("click", function (e) {
    e.preventDefault();
    var dataId = $(this).closest(".upsell").attr("data-id");
    CartJS.addItem(
      dataId,
      1,
      {},
      {
        success: function success(data, textStatus, jqXHR) {
          jQuery.getJSON("/cart.js", function (cart) {
            refreshMiniCart(cart);
          });
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          alert("Error: " + errorThrown + "!");
        },
      }
    );
  }); // Mini Cart Qty

  $(".mini-cart__list").on("click", ".js-qty--mini", function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find("input");
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    var lineData = $this.closest(".product").data("lineid");
    var lineNum = $('[data-lineID="' + lineData + '"]').index();

    if ($this.hasClass("js-qty--plus")) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }

    CartJS.updateItem(
      lineNum + 1,
      qtyInputVal,
      {},
      {
        success: function success(data, textStatus, jqXHR) {
          jQuery.getJSON("/cart.js", function (cart) {
            refreshMiniCart(cart);
          });
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log("Error: " + errorThrown + "!");
          console.log(textStatus);
          console.log(jqXHR);
        },
      }
    );
  });
});

function validateEmail($email) {
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  return emailReg.test($email);
}

var firstFocusableElement, lastFocusableElement;
function trapMiniFocus(event) {
  if (!$(".mini-cart").hasClass("is-open")) return;

  var focusableElements = $(".mini-cart").find(
    'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
  );
  firstFocusableElement = focusableElements[0];
  lastFocusableElement = focusableElements[focusableElements.length - 1];

  if (event.key === "Tab" || event.keyCode === 9) {
    if (event.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstFocusableElement) {
        event.preventDefault();
        lastFocusableElement.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastFocusableElement) {
        event.preventDefault();
        firstFocusableElement.focus();
      }
    }
  }
}

function trapMobileMenuFocus(event) {
  var focusableElements = $(".mobile-menu").find(
    'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
  );
  firstFocusableElement = focusableElements[0];
  lastFocusableElement = focusableElements[focusableElements.length - 1];

  if (event.key === "Tab" || event.keyCode === 9) {
    if (event.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstFocusableElement) {
        event.preventDefault();
        lastFocusableElement.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastFocusableElement) {
        event.preventDefault();
        firstFocusableElement.focus();
      }
    }
  }
}

function closeMini() {
  var cartIcon = $(".header .icon--cart");
  /*var expanded =  cartIcon.attr('aria-expanded') === 'true';
    cartIcon.attr('aria-expanded', !expanded);*/

  $(".mini-cart").removeClass("is-open");
  $(".mini-cart").fadeOut("fast");
  $(".icon--cart").focus();

  document.removeEventListener("keydown", trapMiniFocus);
}

function showMini() {
  var cartIcon = $(".header .icon--cart");
  /*var expanded =  cartIcon.attr('aria-expanded') === 'true';
    cartIcon.attr('aria-expanded', !expanded);*/
  $(".mini-cart").fadeIn("fast");
  $(".mini-cart").addClass("is-open");
  $(".mini-cart .close").focus(); // Set height of product list for full-height mini-cart

  var miniHead = parseInt($(".mini-cart__header").innerHeight());
  var miniShip = parseInt($(".mini-cart__ship").innerHeight());
  var miniFooter = parseInt($(".mini-cart__footer").innerHeight());
  var miniUp = parseInt($(".mini-cart__upsell").innerHeight());
  var miniTotalHeight = miniHead + miniShip + miniFooter + miniUp; // $( '.mini-cart__list' ).css( 'max-height', 'calc( 100vh - '+miniTotalHeight+'px )' );

  document.addEventListener("keydown", trapMiniFocus);
}

function refreshMiniCart(cartData) {
  var cartItems = cartData.items;
  var newCartHtml = ""; // Free shipping updater

  var totalShip = parseInt($(".mini-cart").data("freeship"));
  var newCartTotal = cartData.items_subtotal_price;
  var awayShip = totalShip - newCartTotal;
  var shipPercent = (newCartTotal / totalShip) * 100;

  if (shipPercent >= 100) {
    $(".shipping-bar--progress").css("width", "100%");
    $(".mini-cart__ship").addClass("is-free");
    $(".shipping-bar").attr("aria-valuenow", "100%").attr("aria-busy", "false");
  } else {
    if ($(".mini-cart__ship").hasClass("is-free")) {
      $(".mini-cart__ship").removeClass("is-free");
    }

    $(".free-count").text(formatter.format(awayShip / 100));
    $(".shipping-bar--progress").css("width", shipPercent + "%");
    $(".shipping-bar")
      .attr("aria-valuenow", shipPercent + "%")
      .attr("aria-busy", "true");
  } // Build html of new products in cart

  $.each(cartItems, function (index, item) {
    // console.log( item );
    // Opening
    newCartHtml +=
      '<div role="group" aria-label="product" class="product product--cart d-flex justify-between" data-lineid="' +
      (index + 1) +
      '">';
    newCartHtml += ' <div class="product__image">';

    if (item.featured_image) {
      //item.image.alt
      newCartHtml += '<a href="' + item.url + '">';
      newCartHtml +=
        '<img src="' +
        item.featured_image.url
          .replace(".jpg", "_80x.jpg")
          .replace(".png", "_80x.png") +
        '" srcset="' +
        item.featured_image.url
          .replace(".jpg", "_160x.jpg")
          .replace(".png", "_160x.png") +
        ' 2x" alt="Go to ' +
        item.product_title +
        '">';
      newCartHtml += "</a>";
    }

    newCartHtml += "</div>";
    newCartHtml += '<div class="product__info">';
    newCartHtml += '<div class="title d-flex">';
    newCartHtml += '<h3 class="heading--six d-flex justify-between">';
    newCartHtml += '<a class="no-dec trans" href="' + item.url + '">';
    newCartHtml += item.product_title;
    newCartHtml += "</a>";
    newCartHtml +=
      ' <button class="remove-product trans"><span class="sr-only">Remove</span><img src="//cdn.shopify.com/s/files/1/0506/7037/0997/t/2/assets/icon-close.svg?v=18585775398919142161649090024" alt="" /></button>';
    newCartHtml += "</h3>";

    if (item.variant_options != null) {
      newCartHtml += '<span class="var">';
      $.each(item.variant_options, function (index, value) {
        if (value != "Default Title") {
          if (index != 0) {
            newCartHtml += " / ";
          }

          newCartHtml += value;
        }
      });
      newCartHtml += "</span>";
    }

    if (item.hasOwnProperty("selling_plan_allocation")) {
      newCartHtml +=
        '<span class="delivery">' +
        item.selling_plan_allocation.selling_plan.name +
        "</span>";
    }

    newCartHtml += "</div>"; // newCartHtml += '<div class="price">'+formatter.format(item.final_line_price / 100)+'</div>';

    newCartHtml +=
      '<div class="actions d-flex align-center justify-between">\n          <div class="action action--qty">\n            <div class="qty d-flex align-center">\n              <button class="js-qty js-qty--mini js-qty--minus trans">\n                <span class="sr-only">Decrease</span>\n              </button>\n              <input sm-rc-quantity-selector type="text" value="' +
      item.quantity +
      '" min="1"  type="number" class="qty-val" />\n              <button class="js-qty js-qty--mini js-qty--plus trans">\n                <span class="sr-only">Increase</span>\n              </button>\n            </div>\n          </div>';
    newCartHtml +=
      '<div class="price">' +
      formatter.format(item.final_line_price / 100) +
      "</div>";
    newCartHtml += "</div>"; // Closing

    newCartHtml += "</div>";
    newCartHtml += "</div>";
  }); // Clear current products in cart

  $(".mini-cart__items").empty(); // Set new subtotal

  $(".mini-cart__footer .sub-total .total").text(
    formatter.format(cartData.total_price / 100)
  ); // Set new header icon count

  $(".icon--cart .cart-count span ").text(cartData.item_count); // Add updated producst to mini cart

  $(".mini-cart__list").html(newCartHtml); // Show mini cart

  showMini();
}
function successState() {
  // success state goes here.
  // console.log('added');
  setTimeout(function () {
    jQuery.getJSON("/cart.js", function (cart) {
      refreshMiniCart(cart);
      $("[sm-rc-add-to-cart]").prop("disabled", false).removeClass("loading");
    });
  }, 200);
}
jQuery(document)
  .ready(function ($) {
    // Check for cookie for modal newsletter popup
    if (getCookie("modalNewsletter") != "Hidden") {
      setTimeout(function () {
        $(".modal--newsletter").fadeIn("fast");
      }, 3000);
    }

    $(".modal--close, .modal__bg").on("click", function (e) {
      closeModal($(this)); // Check for and set cookie modal newsletter popup

      if ($(this).closest(".modal").hasClass("modal--newsletter")) {
        setCookie("modalNewsletter", "Hidden");
      }
    }); // Video modal

    $(".btn--video").on("click", function (e) {
      e.preventDefault();
      var videoID = $(this).attr("data-video");
      var videoType = $(this).attr("data-type");

      if (videoType == "vimeo") {
        $(this)
          .closest("section")
          .find(".modal--video .modal__inner")
          .append(
            '<div class="iframe-wrap"><iframe width="560" height="315" src="https://player.vimeo.com/video/' +
              videoID +
              '"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen allowfullscreen></iframe></div>'
          );
      } else if (videoType == "youtube") {
        $(this)
          .closest("section")
          .find(".modal--video .modal__inner")
          .append(
            '<div class="iframe-wrap"><iframe width="560" height="315" src="https://www.youtube.com/embed/' +
              videoID +
              '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>'
          );
      }

      $(this).closest("section").find(".modal--video").fadeIn();
    }); // Expert modal

    $(".clue a").on("click", function (e) {
      e.preventDefault();
      setLastFocused(e.currentTarget);
      let modal = $(this).closest(".clue").find(".modal");
      modal.fadeIn("fast", function () {
        gateModal(modal.find(".modal__wrap"));
      });
    });
    $(".tab__herbs .note .note__info a").on("click", function (e) {
      e.preventDefault();
      setLastFocused(e.currentTarget);
      let modal = $(this).closest(".note").find(".modal");
      modal.fadeIn("fast", function () {
        gateModal(modal.find(".modal__wrap"));
      });
    });
  })
  .on("click", ".experts-list .expert a", function (e) {
    e.preventDefault();
    setLastFocused($(e.target));
    var dataIndex = $(this).closest(".expert").attr("data-index");
    $(".modal__slider").css("height", "50px");
    $(".modal__slider").css("overflow", "hidden");
    $(".modal__slider").css("opacity", "0");
    $(this)
      .closest("section")
      .find(".modal--experts")
      .fadeIn("fast", function () {
        $(".modal__slider").css("height", "unset");
        $(".modal__slider").css("overflow", "unset");
        $(".modal__slider").css("opacity", "1");
        $(".modal__slider").slick("setPosition");
        $(".modal__slider").slick("slickGoTo", dataIndex); // $('.modal__slider .arrows').show();
        gateModal($(this).find(".modal__wrap"));
      });
  });

function closeModal(object) {
  object
    .closest(".modal")
    .attr("tabindex", "-1")
    .fadeOut("fast", function () {
      $(".modal__inner .iframe-wrap").remove();

      if (object.closest(".modal").hasClass("modal--pdp")) {
        object
          .closest(".modal")
          .find(".modal__slider--main")
          .slick("unslick")
          .remove();
        object
          .closest(".modal")
          .find(".modal__slider--thumb")
          .slick("unslick")
          .remove();
      }
      focusLastFocused();
    });
}

function setCookie(cookieName, cookieValue) {
  var today = new Date();
  var expire = new Date();
  expire.setTime(today.getTime() + 3600000 * 24 * 7);
  document.cookie =
    cookieName +
    "=" +
    encodeURI(cookieValue) +
    ";expires=" +
    expire.toGMTString();
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}
// jQuery( document ).ready( function( $ ) {
//   // PRE-FETCH IMAGES
//   function prefetchImages(url) {
//     var xhr = new XMLHttpRequest();
//     xhr.open('GET', url, true);
//     xhr.onreadystatechange = function() {
//       if (xhr.readyState == 4) {
//         var parser = new DOMParser();
//         var doc = parser.parseFromString(xhr.responseText, 'text/html');
//         var images = doc.getElementsByTagName('img');
//         for (var i = 0; i < images.length; i++) {
//           var img = images[i];
//           var src = img.getAttribute('src');
//           var xhr2 = new XMLHttpRequest();
//           xhr2.open('GET', src, true);
//           xhr2.send();
//         }
//       }
//     };
//     xhr.send();
//   }
//   function elementScrolled(elem){
//     var docViewTop = $(window).scrollTop();
//     var docViewBottom = docViewTop + $(window).height();
//     var elemTop = $(elem).offset().top;
//     return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
//   }
//   function preloadVisibleLinks(){
//     if(elementScrolled('a')) {
//       var thisHref = elementScrolled.attr('href');
//       if (typeof thisHref !== 'undefined' && attr !== false) {
//         prefetchImages(thisHref);
//       }
//     }
//   }
//   $(window).scroll(function(){
//     preloadVisibleLinks();
//   });
//   preloadVisibleLinks();
// } )
jQuery(document).ready(function ($) {
  $(".alert-bar__slider").on("init", function(event, slick) {
    headerOffset(); 
  });
  $(".alert-bar__slider").slick({
    infinite: true,
    slidesToShow: 1,
    // vertical: true,
    prevArrow: "",
    nextArrow: '<i class="tm-icon-arrow-right-green"></i>',
    autoplay: true,
    dots: false,
    arrows: true,
    autoplaySpeed: 3500,
    rows: 0,
    instructionsText:
      "This is an auto-rotating carousel. Use the play and pause buttons to control the slides when multiple slides are available.",
  });
  $(".home-hero__slider .slider").slick({
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    arrows: false,
    speed: 1000,
    dots: false,
    noRole: true,
    asNavFor: ".home-hero__slider .slider__nav", // responsive: [
    //   {
    //     breakpoint: 992,
    //     settings: {
    //       arrows: false,
    //       dots: true
    //     }
    //   }
    // ]
  });
  $(".home-hero__slider .slider__nav").slick({
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    speed: 1000,
    dots: false,
    focusOnSelect: true,
    noRole: true,
    asNavFor: ".home-hero__slider .slider", // responsive: [
    //   {
    //     breakpoint: 576,
    //     settings: {
    //       arrows: false
    //     }
    //   }
    // ]
  }); // Set aria-current atts on slick dots

  $(".icon-slider--simple .slider").on(
    "init",
    function (event, slick, currentSlide, nextSlide) {
      $(this).find(".slick-dots li button").attr("aria-current", "false");
      $(this)
        .find(".slick-dots li:first-child button")
        .attr("aria-current", "true");
    }
  );
  $(".icon-slider--simple .slider").slick({
    infinite: true,
    slidesToShow: 6,
    accessibility: false,
    slidesToScroll: 3,
    autoplay: false,
    fade: false,
    dots: true,
    arrows: true,
    autoplaySpeed: 1500,
    speed: 1000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }); // Set aria-current atts on slick dots

  $(".icon-slider--simple .slider").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      $(this).find(".slick-dots li button").attr("aria-current", "false");
      $(this)
        .find(".slick-dots .slick-active button")
        .attr("aria-current", "true");
    }
  );
  $(".icon-slider--complex:not( .icon-slider--tabs ) .slider").slick({
    infinite: true,
    slidesToShow: 4,
    accessibility: false,
    slidesToScroll: 2,
    autoplay: false,
    fade: false,
    dots: true,
    arrows: true,
    autoplaySpeed: 1500,
    speed: 1000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 578,
        settings: "unslick",
      },
    ],
  });
  $(".icon-slider--tabs .slider").slick({
    infinite: true,
    slidesToShow: 4,
    accessibility: false,
    slidesToScroll: 4,
    autoplay: false,
    fade: false,
    dots: true,
    arrows: true,
    autoplaySpeed: 1500,
    speed: 1000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 578,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }); // Set aria-current atts on slick dots

  $(".tab-slider").on("init", function (event, slick, currentSlide, nextSlide) {
    $(this).find(".slick-dots li button").attr("aria-current", "false");
    $(this)
      .find(".slick-dots li:first-child button")
      .attr("aria-current", "true");
  });
  $(".tab-slider .tab .slider").slick({
    infinite: true,
    slidesToShow: 4,
    accessibility: false,
    slidesToScroll: 4,
    autoplay: false,
    fade: false,
    dots: true,
    arrows: true,
    autoplaySpeed: 1500,
    speed: 1000,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1, // centerMode: true,
          // variableWidth: true,
        },
      },
    ],
  }); // Set aria-current atts on slick dots

  $(".tab-slider").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      $(this).find(".slick-dots li button").attr("aria-current", "false");
      $(this)
        .find(".slick-dots .slick-active button")
        .attr("aria-current", "true");
    }
  ); // Set aria-current atts on slick dots

  $(".article-slider .slider").on(
    "init",
    function (event, slick, currentSlide, nextSlide) {
      $(this).find(".slick-dots li button").attr("aria-current", "false");
      $(this)
        .find(".slick-dots li:first-child button")
        .attr("aria-current", "true");
    }
  );
  $(".article-slider .slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    accessibility: false,
    autoplay: false,
    fade: false,
    dots: true,
    arrows: true,
    autoplaySpeed: 1500,
    speed: 1000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 578,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }); // Set aria-current atts on slick dots

  $(".article-slider .slider").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      $(this).find(".slick-dots li button").attr("aria-current", "false");
      $(this)
        .find(".slick-dots .slick-active button")
        .attr("aria-current", "true");
    }
  ); // Generic Product Slider

  $(".product-slider--lg .slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: false,
    fade: false,
    dots: true,
    arrows: true,
    autoplaySpeed: 1500,
    speed: 1000,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1, // centerMode: true,
          // variableWidth: true,
        },
      },
    ],
  }); // Article product slider

  $(".featured-simple-products .pdp__related__grid").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: false,
    fade: false,
    dots: false,
    arrows: true,
    prevArrow: '<button class="featured-simple-products__prev" type="button" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true"><path d="M15.262 7.292a.98.98 0 0 1 0 1.416l-6.24 5.985a1.018 1.018 0 1 1-1.41-1.47L12.016 9H1.003a1 1 0 0 1 0-1.999h11.013L7.612 2.777a1.018 1.018 0 1 1 1.41-1.47l6.24 5.985Z" /></svg></button>',
    nextArrow: '<button class="featured-simple-products__next" type="button" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true"><path d="M15.262 7.292a.98.98 0 0 1 0 1.416l-6.24 5.985a1.018 1.018 0 1 1-1.41-1.47L12.016 9H1.003a1 1 0 0 1 0-1.999h11.013L7.612 2.777a1.018 1.018 0 1 1 1.41-1.47l6.24 5.985Z" /></svg></button>',
    autoplaySpeed: 1500,
    speed: 1000,
    rows: 0,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1, 
        },
      },
    ],
  });

  $(".product-slider--sm .slider").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    fade: false,
    dots: true,
    arrows: true,
    autoplaySpeed: 1500,
    speed: 1000,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1, // centerMode: true,
          // variableWidth: true,
        },
      },
    ],
  });
  $(".pdp__social .slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    fade: false,
    dots: true,
    arrows: true,
    autoplaySpeed: 1500,
    speed: 1000,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1, // centerMode: true,
          // variableWidth: true,
        },
      },
    ],
  }); // Top newsbar marquee

  $(".ticker .slider").slick({
    speed: 9000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    pauseOnHover: true,
  }); // Set aria-current atts on slick dots

  // // Initialization for thumbnail slider
  // $(".pdp__images--default .pdp__slider--thumb").on("init", function(event, slick) {
  //     console.log("Thumbnail slider initialized.");
  //     $(this).find(".slick-slide").attr("aria-current", "false");
  //     $(this).find(".slick-slide.slick-current").attr("aria-current", "true");
  //     $(this).find(".slick-dots li button").attr("aria-current", "false");
  //     $(this).find(".slick-dots li:first-child button").attr("aria-current", "true");
  // });

  // $(".pdp__images--default .pdp__slider--thumb").slick({
  //     infinite: true,
  //     arrows: false,
  //     accessibility: false,
  //     dots: true,
  //     slidesToShow: 6,
  //     vertical: true,
  //     focusOnSelect: true, // Ensure focusOnSelect is set to true
  //     asNavFor: ".pdp__images--default .pdp__slider--main",
  //     useGroupRole: false,
  //     noRole: true,
  //     responsive: [
  //         {
  //             breakpoint: 993,
  //             settings: {
  //                 slidesToShow: 6,
  //                 vertical: false,
  //             },
  //         },
  //         {
  //             breakpoint: 577,
  //             settings: {
  //                 slidesToShow: 3,
  //                 vertical: false,
  //             },
  //         },
  //     ],
  //     rows: 0
  // }).on("afterChange", function(event, slick, currentSlide) {
  //     console.log("Thumbnail slider afterChange event. Current slide: ", currentSlide);
  //     $(this).find(".slick-slide").attr("aria-current", "false");
  //     $(this).find(".slick-dots li button").attr("aria-current", "false");
  //     $(this).find(".slick-slide.slick-current").attr("aria-current", "true");
  //     $(this).find(".slick-dots .slick-active button").attr("aria-current", "true");
  // });

  // // Initialization for main slider
  // $(".pdp__images--default .pdp__slider--main").slick({
  //     infinite: true,
  //     fade: true,
  //     accessibility: false,
  //     arrows: true,
  //     dots: false,
  //     noRole: true,
  //     asNavFor: ".pdp__images--default .pdp__slider--thumb"
  // }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  //     console.log("Main slider beforeChange event. Current slide: ", currentSlide, " Next slide: ", nextSlide);
  //     var currentVideo = $(this).find('.slick-current video');
  //     // pause current slide video
  //     if(currentVideo.length) {
  //         currentVideo.get(0).pause();
  //     }
  // });

  // // Click event listener to manually sync thumbnail clicks with the main slider
  // $(".pdp__images--default .pdp__slider--thumb").on('click', '.slick-slide', function(event) {
  //     var index = $(this).data("slick-index");
  //     console.log("Thumbnail clicked. Slide index: ", index);
  //     $(".pdp__images--default .pdp__slider--main").slick('slickGoTo', index);
  // });

  $(".gallery .slider").slick({
    infinite: false,
    // slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    accessibility: false,
    variableWidth: true,
    fade: false,
    dots: true,
    arrows: true,
    autoplaySpeed: 1500,
    speed: 1000,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // centerMode: true,
          variableWidth: false,
          adaptiveHeight: true,
        },
      },
    ],
  }); // Experts modal slider

  $(".pdp__images--default .video-thumb .play-icon").on("click", function () {
    $(this).parent().hide();
    $(this)
      .parent()
      .next(".video-container")
      .css("display", "flex")
      .find("video")
      .get(0)
      .play();
  });

  $(" #shopify-section-about-directors .modal--experts .modal__slider").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: false,
    autoplay: false,
    // variableWidth: true,
    fade: true,
    dots: false,
    arrows: true,
    // appendArrows: '.modal--experts .modal__footer .arrows',
    prevArrow: $("#shopify-section-about-directors .prev"),
    nextArrow: $("#shopify-section-about-directors .next"), // autoplaySpeed: 1500,
    // speed: 1000,
    //  responsive: [
    //   {
    //     breakpoint: 1281,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 1,
    //     }
    //   },
    //   {
    //     breakpoint: 768,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 1,
    //     }
    //   },
    //   {
    //     breakpoint: 568,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //       // centerMode: true,
    //       // variableWidth: true,
    //     }
    //   }
    // ]
  });
  $("#shopify-section-about-leadership .modal--experts .modal__slider").slick({
    infinite: false,
    slidesToShow: 1,
    accessibility: false,
    slidesToScroll: 1,
    autoplay: false,
    // variableWidth: true,
    fade: true,
    dots: false,
    arrows: true,
    // appendArrows: '.modal--experts .modal__footer .arrows',
    prevArrow: $("#shopify-section-about-leadership .prev"),
    nextArrow: $("#shopify-section-about-leadership .next"), // autoplaySpeed: 1500,
    // speed: 1000,
    //  responsive: [
    //   {
    //     breakpoint: 1281,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 1,
    //     }
    //   },
    //   {
    //     breakpoint: 768,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 1,
    //     }
    //   },
    //   {
    //     breakpoint: 568,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //       // centerMode: true,
    //       // variableWidth: true,
    //     }
    //   }
    // ]
  });
  $("#shopify-section-about-advisors .modal--experts .modal__slider").slick({
    infinite: false,
    slidesToShow: 1,
    accessibility: false,
    slidesToScroll: 1,
    autoplay: false,
    // variableWidth: true,
    fade: true,
    dots: false,
    arrows: true,
    // appendArrows: '.modal--experts .modal__footer .arrows',
    prevArrow: $("#shopify-section-about-advisors .prev"),
    nextArrow: $("#shopify-section-about-advisors .next"), // autoplaySpeed: 1500,
    // speed: 1000,
    //  responsive: [
    //   {
    //     breakpoint: 1281,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 1,
    //     }
    //   },
    //   {
    //     breakpoint: 768,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 1,
    //     }
    //   },
    //   {
    //     breakpoint: 568,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //       // centerMode: true,
    //       // variableWidth: true,
    //     }
    //   }
    // ]
  });
  $("#shopify-section-experts-list .modal--experts .modal__slider").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: false,
    autoplay: false,
    // variableWidth: true,
    fade: true,
    dots: false,
    arrows: true,
    // appendArrows: '.modal--experts .modal__footer .arrows',
    prevArrow: $("#shopify-section-experts-list .prev"),
    nextArrow: $("#shopify-section-experts-list .next"), // autoplaySpeed: 1500,
    // speed: 1000,
    //  responsive: [
    //   {
    //     breakpoint: 1281,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 1,
    //     }
    //   },
    //   {
    //     breakpoint: 768,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 1,
    //     }
    //   },
    //   {
    //     breakpoint: 568,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //       // centerMode: true,
    //       // variableWidth: true,
    //     }
    //   }
    // ]
  });
  $(".experts-list .slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    accessibility: false,
    fade: false,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1, // centerMode: true,
          // variableWidth: true,
        },
      },
    ],
  });
  $(".experts-resources .slider").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    accessibility: false,
    autoplay: false,
    fade: false,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1, // centerMode: true,
          // variableWidth: true,
        },
      },
    ],
  });
  $(".press__featured .slider").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    accessibility: false,
    autoplay: false,
    fade: false,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1, // centerMode: true,
          // variableWidth: true,
        },
      },
    ],
  });
  $(".careers-reviews .slider").slick({
    infinite: true,
    fade: true,
    arrows: true,
    accessibility: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  $(".about-timeline .timeline__events .slider").slick({
    infinite: false,
    fade: true,
    arrows: false,
    accessibility: false,
    dots: false,
    slidesToShow: 1,
    adaptiveHeight: true,
    draggable: false,
    swipe: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          swipe: true,
        },
      },
    ], // asNavFor: '.about-timeline .timeline__years .slider'
  });
  $(".slider").each(function () {
    var $this = $(this);
    var myInterval = setInterval(function () {
      if ($this.hasClass("slider")) {
        $this.fadeIn(200);
        $this.slick("setPosition");
        clearInterval(myInterval);
      }
    }, 150);
  });
  var lazyLoadInstance = new LazyLoad({
    // Your custom settings go here
  });
});
// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file.
//console.log("This site was developed by https://www.sleeplessmedia.com"); // Create our number formatter.

var formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD", // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

// Subscription text disclaimer function
window.addEventListener("ReChargeWidget-loaded", () => {
  window.ReChargeWidget.eventService.addEventListener(
    "widget:build",
    (widget) => {
      $(".rc_widget__option--subsave").on("click", function (event) {
        document.getElementById("comp").style.display = "block";
      });

      $(".rc_widget__option--onetime").on("click", function (event) {
        document.getElementById("comp").style.display = "none";
      });
    }
  );
});

function showComp() {
  $("#comp").show();
  return false;
}
function hideComp() {
  $("#comp").hide();
  return false;
}
//Sleepify Starter Theme by Sleepless Media
//This file is intended to be used for small ongoing fixes or changes post-launch.

/**
 *
 */
function gateModal(modal) {
  if (!modal || !modal.length) return;
  modal.attr("tabindex", "0");
  modal.focus();

  if (!modal.attr("aria-label") && !modal.attr("aria-labelledby")) {
    let lf = getLastFocused();
    if (lf) {
      let label = lf.text();
      if (label && label.length < 200) modal.attr("aria-label", label);
    }
  }

  modal.off("keydown").on("keydown", (e) => {
    if (!modal[0].contains(e.target)) {
      modal.focus();
    }
    let focusableElements = modal
      .find(
        "[role='button'], button:visible, .close, .featherlight-close, video, iframe, a, input:not([type='hidden'])"
      )
      .not("[tabindex=-1]");
    let firstFocusableElement = focusableElements[0];
    let lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (e.target == firstFocusableElement && e.key == "Tab" && e.shiftKey) {
      e.preventDefault();
      lastFocusableElement.focus();
    } else if (
      (e.target == lastFocusableElement && e.key == "Tab" && !e.shiftKey) ||
      (e.target == modal[0] && e.key == "Tab" && e.shiftKey)
    ) {
      e.preventDefault();
      firstFocusableElement.focus();
    }
  });
}

function initLabelledInputs() {
  $(".labelled input, .labelled select, .labelled textarea").each(function () {
    let input = $(this);
    let div = input.closest(".labelled");
    let label = div.find("label");
    label.toggleClass("sr-only", !input.val());
    input.on("input change", function (e) {
      label.toggleClass("sr-only", !e.target.value);
    });
  });
}

function initForms() {
  $("form.validate [type=submit]").on("click", validateFormEvent);
  $("form.validate [aria-required=true], form.validate [required]").each(
    function () {
      let field = $(this);
      let id = this.id;
      let name = field.attr("name");
      let label = (
        field.prev("label").text() ||
        field.closest("div").find("label").text() ||
        name
      ).replace(/\s?\*\s?$/, "");
      let errid =
        field.attr("aria-errormessage") ||
        "error-" + (id ? id : Math.round(Math.random() * 100000));
      if (!$(`#${errid}`).length)
        $(
          '<div aria-live="off" class="error-msg sr-only" id="' +
            errid +
            '">' +
            label +
            " is required</div>"
        ).insertAfter(field);
      field.attr("aria-invalid", "false").attr("aria-errormessage", errid);
    }
  );
}

function validateFormEvent(e) {
  e.preventDefault();
  let form = e.target.closest("form");
  validateForm(form).then(
    () => {
      $(form).submit();
    },
    (errors) => {
      $(form).find(`[aria-invalid=true]`).first().focus();
    }
  );
}

function validateForm(form) {
  return new Promise(function (resolve, reject) {
    form = $(form);
    let required_fields = form.find("[aria-required=true], [required]");
    let errors = {};
    let error_div = form.find(".message.error");
    required_fields.removeAttr("aria-invalid");
    if (required_fields.length) {
      required_fields.each(function () {
        let field = $(this);
        let name = field.attr("name");
        let label = (
          field.prev("label").text() ||
          field.closest("div").find("label").text() ||
          name
        ).replace(/\s?\*\s?$/, "");
        let val = ["checkbox", "radio"].includes(field.attr("type"))
          ? form.find(`[name="${name}"]:checked`).val()
          : field.val();
        let errid = field.attr("aria-errormessage");
        let error_el = $(`#${errid}`);
        if (!val) {
          errors[name] = label + " is required";
          field.attr("aria-invalid", "true");
          if (error_el.length) $(`#${errid}`).removeClass("sr-only");
        } else if (error_el.length) {
          error_el.addClass("sr-only");
        }
      });
    }
    if (!Object.keys(errors).length) {
      resolve();
    } else {
      reject(errors);
    }
  });
}

function ADA() {
  //ADA js overrides
  $(".pdp__tabs #tabpanel-details .tab__content strong").each(function () {
    $(this)
      .unwrap()
      .replaceWith("<h4>" + this.innerHTML + "</h4>");
  });

  //code below has no effect so far
  let addr_modal = document.getElementById("myModal-container");
  if (addr_modal) {
    observeDOM(addr_modal, function () {
      $("#myModal-container #btn-update-address").attr("aria-label", "Close");
    });
  }
}

function checkPdpGallerySlider() {
  if ($(window).width() <= 768) {
    if (!$(".pdp__gallery").hasClass("slick-initialized")) {
      initPdpGallerySlider();
    } else {
    }
  } else {
    if ($(".pdp__gallery").hasClass("slick-initialized")) {
      $(".pdp__gallery").slick("unslick");
    }
  }
}
function moveSubpageHeroSubtitle() {
  const $subtitle = $('.subpage-hero__subtitle');
  const $section = $('.subpage-hero');
  const $aside = $('.subpage-hero aside');

  if ($(window).width() < 768) {
    if (!$subtitle.parent().is($section)) {
      $subtitle.appendTo($section);
    }
  } else {
    if (!$subtitle.parent().is($aside)) {
      $subtitle.appendTo($aside);
    }
  }
}
function initPdpGallerySlider() {
  if ($(window).width() <= 768) {
    $(".pdp__gallery")
      .slick({
        accessibility: false,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        rows: 1,
      })
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        $(".pdp__gallery")
          .find("video")
          .each(function () {
            this.pause();
          });
      });
  }
}

function checkVideoCardsSlider() {
  if ($(window).width() <= 768) {
    if (!$(".video-cards__grid").hasClass("slick-initialized")) {
      initVideoCardsSlider();
    } else {
    }
  } else {
    if ($(".video-cards__grid").hasClass("slick-initialized")) {
      $(".video-cards__grid").slick("unslick");
    }
  }
}
function initVideoCardsSlider() {
  if ($(window).width() <= 768) {
    $(".video-cards__grid")
      .slick({
        accessibility: false,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        rows: 1,
      })
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        $(".video-cards__grid")
          .find("video")
          .each(function () {
            this.pause();
          });
      });
  }
}

("use strict");
(function (C, g) {
  "function" === typeof define && define.amd
    ? define([], g)
    : "object" === typeof module && module.exports
    ? (module.exports = g())
    : (C.Rellax = g());
})("undefined" !== typeof window ? window : global, function () {
  var C = function (g, q) {
    function P() {
      if (
        3 === a.options.breakpoints.length &&
        Array.isArray(a.options.breakpoints)
      ) {
        var d = !0,
          c = !0,
          b;
        a.options.breakpoints.forEach(function (f) {
          "number" !== typeof f && (c = !1);
          null !== b && f < b && (d = !1);
          b = f;
        });
        if (d && c) return;
      }
      a.options.breakpoints = [576, 768, 1201];
      console.warn(
        "Rellax: You must pass an array of 3 numbers in ascending order to the breakpoints option. Defaults reverted"
      );
    }
    var a = Object.create(C.prototype),
      p = 0,
      r = 0,
      t = 0,
      k = 0,
      e = [],
      u = !0,
      J =
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        function (d) {
          return setTimeout(d, 1e3 / 60);
        },
      v = null,
      G = !1;
    try {
      var K = Object.defineProperty({}, "passive", {
        get: function () {
          G = !0;
        },
      });
      window.addEventListener("testPassive", null, K);
      window.removeEventListener("testPassive", null, K);
    } catch (d) {}
    var Q =
        window.cancelAnimationFrame ||
        window.mozCancelAnimationFrame ||
        clearTimeout,
      R =
        window.transformProp ||
        (function () {
          var d = document.createElement("div");
          if (null === d.style.transform) {
            var c = ["Webkit", "Moz", "ms"],
              b;
            for (b in c)
              if (void 0 !== d.style[c[b] + "Transform"])
                return c[b] + "Transform";
          }
          return "transform";
        })();
    a.options = {
      speed: -2,
      verticalSpeed: null,
      horizontalSpeed: null,
      breakpoints: [576, 768, 1201],
      center: !1,
      wrapper: null,
      relativeToWrapper: !1,
      round: !0,
      vertical: !0,
      horizontal: !1,
      verticalScrollAxis: "y",
      horizontalScrollAxis: "x",
      callback: function () {},
    };
    q &&
      Object.keys(q).forEach(function (d) {
        a.options[d] = q[d];
      });
    q && q.breakpoints && P();
    g ||= ".rellax";
    g = "string" === typeof g ? document.querySelectorAll(g) : [g];
    if (0 < g.length) {
      a.elems = g;
      if (a.options.wrapper && !a.options.wrapper.nodeType)
        if ((g = document.querySelector(a.options.wrapper)))
          a.options.wrapper = g;
        else {
          console.warn(
            "Rellax: The wrapper you're trying to use doesn't exist."
          );
          return;
        }
      var H,
        F = function () {
          for (var d = 0; d < e.length; d++)
            a.elems[d].style.cssText = e[d].style;
          e = [];
          r = window.innerHeight;
          k = window.innerWidth;
          d = a.options.breakpoints;
          H =
            k < d[0]
              ? "xs"
              : k >= d[0] && k < d[1]
              ? "sm"
              : k >= d[1] && k < d[2]
              ? "md"
              : "lg";
          L();
          for (d = 0; d < a.elems.length; d++) {
            var c = void 0,
              b = a.elems[d],
              f = b.getAttribute("data-rellax-percentage"),
              l = b.getAttribute("data-rellax-speed"),
              h = b.getAttribute("data-rellax-xs-speed"),
              w = b.getAttribute("data-rellax-mobile-speed"),
              x = b.getAttribute("data-rellax-tablet-speed"),
              y = b.getAttribute("data-rellax-desktop-speed"),
              z = b.getAttribute("data-rellax-vertical-speed"),
              A = b.getAttribute("data-rellax-horizontal-speed"),
              D = b.getAttribute("data-rellax-vertical-scroll-axis"),
              E = b.getAttribute("data-rellax-horizontal-scroll-axis"),
              S = b.getAttribute("data-rellax-zindex") || 0,
              T = b.getAttribute("data-rellax-min"),
              U = b.getAttribute("data-rellax-max"),
              V = b.getAttribute("data-rellax-min-x"),
              W = b.getAttribute("data-rellax-max-x"),
              X = b.getAttribute("data-rellax-min-y"),
              Y = b.getAttribute("data-rellax-max-y"),
              m = !0;
            h || w || x || y ? (c = { xs: h, sm: w, md: x, lg: y }) : (m = !1);
            h = a.options.wrapper
              ? a.options.wrapper.scrollTop
              : window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            a.options.relativeToWrapper &&
              (h =
                (window.pageYOffset ||
                  document.documentElement.scrollTop ||
                  document.body.scrollTop) - a.options.wrapper.offsetTop);
            var B = a.options.vertical ? (f || a.options.center ? h : 0) : 0,
              M = a.options.horizontal
                ? f || a.options.center
                  ? a.options.wrapper
                    ? a.options.wrapper.scrollLeft
                    : window.pageXOffset ||
                      document.documentElement.scrollLeft ||
                      document.body.scrollLeft
                  : 0
                : 0;
            h = B + b.getBoundingClientRect().top;
            w = b.clientHeight || b.offsetHeight || b.scrollHeight;
            x = M + b.getBoundingClientRect().left;
            y = b.clientWidth || b.offsetWidth || b.scrollWidth;
            B = f ? f : (B - h + r) / (w + r);
            f = f ? f : (M - x + k) / (y + k);
            a.options.center && (B = f = 0.5);
            c = m && null !== c[H] ? Number(c[H]) : l ? l : a.options.speed;
            z = z ? z : a.options.verticalSpeed;
            A = A ? A : a.options.horizontalSpeed;
            D = D ? D : a.options.verticalScrollAxis;
            E = E ? E : a.options.horizontalScrollAxis;
            l = N(f, B, c, z, A);
            b = b.style.cssText;
            m = "";
            if ((f = /transform\s*:/i.exec(b)))
              (m = b.slice(f.index)),
                (m = (f = m.indexOf(";"))
                  ? " " + m.slice(11, f).replace(/\s/g, "")
                  : " " + m.slice(11).replace(/\s/g, ""));
            e.push({
              baseX: l.x,
              baseY: l.y,
              top: h,
              left: x,
              height: w,
              width: y,
              speed: c,
              verticalSpeed: z,
              horizontalSpeed: A,
              verticalScrollAxis: D,
              horizontalScrollAxis: E,
              style: b,
              transform: m,
              zindex: S,
              min: T,
              max: U,
              minX: V,
              maxX: W,
              minY: X,
              maxY: Y,
            });
          }
          O();
          u && (window.addEventListener("resize", F), (u = !1), I());
        },
        L = function () {
          var d = p,
            c = t;
          p = a.options.wrapper
            ? a.options.wrapper.scrollTop
            : (
                document.documentElement ||
                document.body.parentNode ||
                document.body
              ).scrollTop || window.pageYOffset;
          t = a.options.wrapper
            ? a.options.wrapper.scrollLeft
            : (
                document.documentElement ||
                document.body.parentNode ||
                document.body
              ).scrollLeft || window.pageXOffset;
          a.options.relativeToWrapper &&
            (p =
              ((
                document.documentElement ||
                document.body.parentNode ||
                document.body
              ).scrollTop || window.pageYOffset) - a.options.wrapper.offsetTop);
          return (d != p && a.options.vertical) ||
            (c != t && a.options.horizontal)
            ? !0
            : !1;
        },
        N = function (d, c, b, f, l) {
          var h = {};
          d = 100 * (l ? l : b) * (1 - d);
          c = 100 * (f ? f : b) * (1 - c);
          h.x = a.options.round ? Math.round(d) : Math.round(100 * d) / 100;
          h.y = a.options.round ? Math.round(c) : Math.round(100 * c) / 100;
          return h;
        },
        n = function () {
          window.removeEventListener("resize", n);
          window.removeEventListener("orientationchange", n);
          (a.options.wrapper ? a.options.wrapper : window).removeEventListener(
            "scroll",
            n
          );
          (a.options.wrapper
            ? a.options.wrapper
            : document
          ).removeEventListener("touchmove", n);
          v = J(I);
        },
        I = function () {
          L() && !1 === u
            ? (O(), (v = J(I)))
            : ((v = null),
              window.addEventListener("resize", n),
              window.addEventListener("orientationchange", n),
              (a.options.wrapper ? a.options.wrapper : window).addEventListener(
                "scroll",
                n,
                G ? { passive: !0 } : !1
              ),
              (a.options.wrapper
                ? a.options.wrapper
                : document
              ).addEventListener("touchmove", n, G ? { passive: !0 } : !1));
        },
        O = function () {
          for (var d, c = 0; c < a.elems.length; c++) {
            var b = e[c].verticalScrollAxis.toLowerCase(),
              f = e[c].horizontalScrollAxis.toLowerCase();
            d = -1 != b.indexOf("x") ? p : 0;
            b = -1 != b.indexOf("y") ? p : 0;
            var l = -1 != f.indexOf("x") ? t : 0;
            f = -1 != f.indexOf("y") ? t : 0;
            d = N(
              (d + l - e[c].left + k) / (e[c].width + k),
              (b + f - e[c].top + r) / (e[c].height + r),
              e[c].speed,
              e[c].verticalSpeed,
              e[c].horizontalSpeed
            );
            f = d.y - e[c].baseY;
            b = d.x - e[c].baseX;
            null !== e[c].min &&
              (a.options.vertical &&
                !a.options.horizontal &&
                (f = f <= e[c].min ? e[c].min : f),
              a.options.horizontal &&
                !a.options.vertical &&
                (b = b <= e[c].min ? e[c].min : b));
            null != e[c].minY && (f = f <= e[c].minY ? e[c].minY : f);
            null != e[c].minX && (b = b <= e[c].minX ? e[c].minX : b);
            null !== e[c].max &&
              (a.options.vertical &&
                !a.options.horizontal &&
                (f = f >= e[c].max ? e[c].max : f),
              a.options.horizontal &&
                !a.options.vertical &&
                (b = b >= e[c].max ? e[c].max : b));
            null != e[c].maxY && (f = f >= e[c].maxY ? e[c].maxY : f);
            null != e[c].maxX && (b = b >= e[c].maxX ? e[c].maxX : b);
            a.elems[c].style[R] =
              "translate3d(" +
              (a.options.horizontal ? b : "0") +
              "px," +
              (a.options.vertical ? f : "0") +
              "px," +
              e[c].zindex +
              "px) " +
              e[c].transform;
          }
          a.options.callback(d);
        };
      a.destroy = function () {
        for (var d = 0; d < a.elems.length; d++)
          a.elems[d].style.cssText = e[d].style;
        u || (window.removeEventListener("resize", F), (u = !0));
        Q(v);
        v = null;
      };
      F();
      a.refresh = F;
      return a;
    }
    console.warn("Rellax: The elements you're trying to select don't exist.");
  };
  return C;
});


/*********************************
Cookie functions
***********************************/
//Sets a cookie with the given name and value for the current session.
function setSessionCookie(name, value) {
        let date = new Date();
        document.cookie = name + "=" + value + "; " + "; path=/";
}
//Gets a cookie with the given name.
function getSessionCookie(name) {
      const nameKey = name + "=";
      const cDecoded = decodeURIComponent(document.cookie);
      const cArr = cDecoded .split('; ');
      let res;
      cArr.forEach(val => {
          if (val.indexOf(nameKey) === 0) res = val.substring(nameKey.length);
      })
      return res;
}

/***********************************/
// Start IPStack Geotargeting based on customers zipcode //
function getCookie(e){return document.cookie.length>0&&(c_start=document.cookie.indexOf(e+"="),-1!=c_start)?(c_start=c_start+e.length+1,c_end=document.cookie.indexOf(";",c_start),-1==c_end&&(c_end=document.cookie.length),unescape(document.cookie.substring(c_start,c_end))):""}
function setCookie(e,t,c){var o;if(c){var n=new Date;n.setTime(n.getTime()+24*c*60*60*1e3),o="; expires="+n.toGMTString()}else o="";document.cookie=e+"="+t+o+"; path=/"}
	var zipcode = getCookie("zipcode");
    var access_key = '9da7c901697562382ec847a53ec9dd4e';
    if (zipcode == '') {
      $.ajax({
        url: 'https://api.ipstack.com/check'+'?access_key=' + access_key,   
        dataType: 'jsonp',
        success: function(json) {
          //console.log(json);
          //alert(json.zip);
          if (json.zip) setCookie("zipcode", json.zip, 5);
        }
      });
    }
else {
  console.log('that didnt work');
}

// End IPStack Geotargeting based on customers zipcode //


// Start Geotargeting First Load Fix //
function geoTarget(){
    var zipcode = getCookie("zipcode");
    console.log("fast geo zip " + zipcode);
    $("#enterzipcode").val(zipcode);
    // Directly submit the form
    $("#shipping-arrival").submit();
}

 setTimeout(geoTarget, 1000);
// End Geotargeting First Load Fix //


  function headerOffset() {
    var headerHeight = $(".fixed-wrap").innerHeight();
    var menuAccountHeight = $(".mobile-menu__account").innerHeight();
    var shorthandBar = $("sh-reading-progress-bar");
    var bottomTabHeight =
      $(".privy-tab-container").length > 0
        ? $(".privy-tab-container").innerHeight()
        : 0;

    $("#main").css("padding-top", headerHeight + "px");
    $(".mobile-menu .mobile-menu__menus .inner").css(
      "height",
      "calc( 100vh - " +
        (headerHeight + menuAccountHeight + bottomTabHeight) +
        "px )"
    );
    $(window).on("scroll resize", function () {
      // var newsHeight = $( '.fixed-wrap .alert-bar' ).innerHeight();
      if ($(window).scrollTop() >= 100) {
        $("body").addClass("body-scrolling");
        $(".fixed-wrap").addClass("scrolling"); // if ( newsHeight != undefined ) {
        //   $( '.fixed-wrap' ).css( 'transform', 'translateY(-'+newsHeight+'px)' );
        // }
        if (shorthandBar.length > 0) {
          if ($(window).width() <= 1100) {
            $("sh-reading-progress-bar").css("top", headerHeight + "px");
          } else {
            $("sh-reading-progress-bar").css(
              "top",
              headerHeight + $(".header-main").innerHeight() + "px"
            );
          }
        }
      } else {
        $("body").removeClass("body-scrolling");
        $(".fixed-wrap").removeClass("scrolling"); // $( '.fixed-wrap' ).css( 'transform', 'translateY(0)' );
        // $( '.mobile-menu' ).css( 'margin-top', '0' );
        // $( '.mini-cart' ).css( 'margin-top', '0' );
        if (shorthandBar.length > 0) {
          shorthandBar.css("top", "0px");
        }
      }
    });
  }

function switchToBlogTabIfNoProducts() {
    observeDOM($('.collection__list .boost-pfs-search-result-panel-controls').get(0), function () {
      var $items = $('.collection__list .boost-pfs-search-result-panel-item');
      var $productTab = $items.eq(0).find('button');
      var $blogTab = $items.eq(1).find('button');

      if ($productTab.length && $productTab.text().trim() === 'Products (0)') {
        $blogTab.trigger('click');
      }
    });
}